import { useLanguage } from "@/i18n";
import { scrollToId } from "@/components/Navbar";
import { Flame } from "lucide-react";

export default function Footer() {
  const { t } = useLanguage();
  return (
    <footer data-testid="footer" className="border-t border-stroke/60 bg-black/40">
      <div className="max-w-7xl mx-auto px-5 sm:px-8 py-14 flex flex-col sm:flex-row items-start sm:items-center justify-between gap-8">
        <div className="flex items-center gap-4">
          <img src="/assets/logo.webp" alt="Curaçao Beach Barbecue" className="w-14 h-14 rounded-full ring-1 ring-sunset/50 object-cover" />
          <div>
            <p className="font-display font-bold">CURAÇAO <span className="text-sunset">BEACH</span> BBQ</p>
            <p className="text-xs text-slate-500 mt-1 max-w-xs">{t.footer.tag}</p>
          </div>
        </div>
        <div className="flex flex-wrap gap-6 text-sm text-slate-400">
          <button onClick={() => scrollToId("included")} className="hover:text-sunset transition-colors">{t.nav.included}</button>
          <button onClick={() => scrollToId("menu")} className="hover:text-sunset transition-colors">{t.nav.menu}</button>
          <button onClick={() => scrollToId("booking")} className="hover:text-sunset transition-colors flex items-center gap-1.5">
            <Flame size={13} className="text-sunset" /> {t.nav.book}
          </button>
        </div>
      </div>
      <div className="border-t border-stroke/40">
        <p className="max-w-7xl mx-auto px-5 sm:px-8 py-5 text-[11px] font-mono tracking-wider text-slate-600">{t.footer.rights} · {t.footer.music}</p>
      </div>
    </footer>
  );
}
